import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-all-discount-list-dialog',
  templateUrl: './all-discount-list-dialog.component.html',
  styleUrls: ['./all-discount-list-dialog.component.scss']
})
export class AllDiscountListDialogComponent implements OnInit {



  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    public _matDialogRef: MatDialogRef<AllDiscountListDialogComponent>,
  ) { }

  ngOnInit(): void {
    console.log("_data", this._data.discountList);

  }

  dynamicStyle(color: any): object {
    return { "background-color": String(color) };
  }
}
